// @flow

import { fragments as dtgOrderStatusFragments } from "../../application/apps/DTGApp/components/DTGOrderStatus/graph";
import { gql } from "@apollo/client";
import { graphql } from '@apollo/client/react/hoc';

const markOrderAsDtgCompleted: any = graphql(
  gql`
    mutation($orderId: ID!) {
      markOrderAsDtgCompleted(orderId: $orderId) {
        errors {
          orderId
        }
        order {
          ...DTGOrderStatus_order
        }
        succeeded
      }
    }
    ${dtgOrderStatusFragments.order}
  `,
  {
    name: "markOrderAsDtgCompleted"
  }
);

export default markOrderAsDtgCompleted;
